import { render, staticRenderFns } from "./CikkValaszto.vue?vue&type=template&id=75d6f2ea&"
import script from "./CikkValaszto.vue?vue&type=script&lang=js&"
export * from "./CikkValaszto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports